import { Select } from '@repo/design-system-kit';
import { useIntl } from 'react-intl';
import { type ForwardedRef, forwardRef } from 'react';
import type { Key } from 'react-aria-components';
import { GERMAN_FREELANCER_COMPANY_TYPES } from '../../../common/constants';

interface LegalFormFreelancerSelectProps {
  value?: string;
  onSelectionChange?: (value: Key) => void;
  onBlur?: () => void;
  isInvalid?: boolean;
  isReadOnly?: boolean;
  errorMessage?: string;
}

export const LegalFormFreelancerSelect = forwardRef(
  (
    {
      value,
      onSelectionChange,
      onBlur,
      isInvalid = false,
      isReadOnly = false,
      errorMessage,
    }: LegalFormFreelancerSelectProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { formatMessage } = useIntl();

    return (
      <Select
        data-hj-suppress
        data-testid="legal-form-freelancer-select"
        errorMessage={errorMessage}
        isInvalid={isInvalid}
        isReadOnly={isReadOnly}
        label={formatMessage({
          id: 'customer-registration-kit.forms.international_organization_info.legal_form_label',
        })}
        onBlur={onBlur}
        onSelectionChange={onSelectionChange}
        placeholder={formatMessage({
          id: 'customer-registration-kit.forms.international_organization_info.solopreneurs.DE-legal-form-placeholder',
        })}
        ref={ref}
        selectedKey={value}
      >
        {GERMAN_FREELANCER_COMPANY_TYPES.map(
          ({ value: id, dropdownLabel }: { value: string; dropdownLabel: string }) => (
            <Select.Option id={id} key={id}>
              {dropdownLabel}
            </Select.Option>
          )
        )}
      </Select>
    );
  }
);

LegalFormFreelancerSelect.displayName = 'LegalFormFreelancerSelect';
